import loader from "./loader";

// defined outside of the loader,
// so that the window.rdt function works even if we do not load the script
var a = (window.rdt = function () {
    a.sendEvent ? a.sendEvent.apply(a, arguments) : a.callQueue.push(arguments);
});
a.callQueue = [];

const load = loader(() => {
    var script = document.createElement("script");
    script.async = true;
    script.src = "https://www.redditstatic.com/ads/pixel.js";
    var firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
    } else {
        document.head.appendChild(script);
    }
});

export default function (...args) {
    load();
    return window.rdt(...args);
}
